/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Connect_Cloud_StorageInputs */



/**
* | output |
* | --- |
* | "Connect my cloud storage" |
*
* @param {Onboarding_Usage_Connect_Cloud_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_connect_cloud_storage = /** @type {((inputs?: Onboarding_Usage_Connect_Cloud_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Connect_Cloud_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Meinen Cloud-Speicher verbinden")
	return /** @type {LocalizedString} */ ("Connect my cloud storage")
});